<template>
    <div class="content_right" ref="content_right">
        <div v-html="currentContent"></div>
        <!-- 图片查看 -->
        <!-- <viewer :images="images"
                @inited="inited"
                class="viewer" ref="viewer">
            <template slot-scope="scope">
                <img v-for="src in scope.images" :src="src" :key="src">
                {{scope.options}}
            </template>
        </viewer> -->
    </div>
</template>

<script>
// import 'viewerjs/dist/viewer.css'
//   import Viewer from "v-viewer/src/component.vue"
//     import $ from 'jquery'
    export default {
        name:'contentRight',
        components: {
           // Viewer
        },
        props:['currentContent'],
        data(){
            return {
                //images:[]
            }
        },
        // methods:{
        //     inited (viewer) {
        //         this.$viewer = viewer
        //     },
        //     show (idx) {
        //          this.$viewer.view(idx);
        //     }
        // },
        // created(){
        //     window.imageView = this.show;
        // },
        mounted(){
             this.$watch('currentContent',function(){
                //内容一旦变化，初始化滚动条在顶部
                this.$refs.content_right.scrollTop = 0;
                // let allImages = [];
                // $('.content_right img').each(function (i,v) {
                //     allImages.push($(v).attr('src'));
                // });
                // allImages= [...new Set(allImages )];
                // this.images = allImages;
                
               //console.log('images',this.images);
            });
        }
       
    }
</script>

<style scoped>
    @import "../css/contents.css"
</style>